import Vue from 'vue'
import Router from 'vue-router'
import $store from '@/store.js'
import Bus from '@/assets/js/vueBus.js'
import Outil from '@/assets/js/utils.js'
// 按需加载书写形式
const Playout = () =>
  import('@/views/Playout')
const PlayoutPlus = () =>
  import('@/views/PlayoutPlus')
Vue.use(Router)
const routes = [{
  path: '/',
  redirect: '/wb'
},
{
  path: '/po',
  name: 'Playout',
  component: Playout,
  meta: {
    title: 'TPlayout'
  }
},
{
  path: '/pop',
  name: 'PlayoutPlus',
  component: PlayoutPlus,
  meta: {
    title: 'TPlayout'
  }
},
// 空白页面
{
  path: '/kb',
  name: 'noAuthority',
  component: () =>
    import('@/views/noAuthority'),
  meta: {
    title: 'TPlayout'
  }
},
// 创建模板页面
{
  path: '/pt',
  name: 'ProgramTemplate',
  component: () =>
    import('@/views/ProgramTemplate'),
  meta: {
    title: 'ProgramTemplate'
  }
},
// Workbench页面
{
  path: '/wb',
  name: 'Workbench',
  component: () =>
    import('@/views/Workbench'),
  meta: {
    title: 'Workbench'
  }
},
// AsRunLog页面
{
  path: '/AsRunLog',
  name: 'AsRunLog',
  component: () =>
    import('@/views/Workbench/AsRunLog.vue'),
  meta: {
    title: 'AsRunLog'
  }
},
// 预览审核页面
{
  path: '/ob',
  name: 'OutputBuffer',
  component: () =>
    import('@/views/OutputBuffer'),
  meta: {
    title: 'OutputBuffer'
  }
},
{
  path: '/cm',
  name: 'ChannelManager',
  component: () =>
    import('@/views/ChannelManager'),
  meta: {
    title: 'ChannelManager'
  }
}
]
const router = new Router({
  routes,
  linkExactActiveClass: 'tabActive'
})
router.beforeEach((to, from, next) => {
  // initconfig接口
  $store.dispatch('common/baseUrl')
  if (from.path == '/') {
    // initLoginUser接口
    $store.dispatch('common/baseUserInfo')
  }
  const ProgramRMessage = sessionStorage.getItem('ProgramRMessage')
  // 判断是否有programId
  if ((to.path == '/pop' || to.path == '/po') && !ProgramRMessage) {
    router.push({
      path: '/wb'
    })
    return
  }

  const pageMark = to.path.split('/')[1]

  if (to.meta.title && to.meta.title != undefined && to.meta.title != 'undefined') {
    document.title = 'TVU Channel'
  } else {
    document.title = 'TVU Channel'
  }
  console.log(pageMark)
  if (['pop', 'po', 'wb', 'cm'].includes(pageMark)) {
    if ((to.query.ProgramId || pageMark == 'wb') && pageMark != 'cm') {
      next()
    } else if (pageMark == 'cm') {
      Outil.getManager((data) => {
        if (data.some(item => item.functionName == 'Manager' && item.functionPermission)) {
          next()
        } else {
          router.push({
            path: '/wb'
          })
        }
      })
    } else {
      next({
        path: to.path,
        query: {
          ProgramId: ProgramRMessage ? JSON.parse(ProgramRMessage).ProgramId : ''
        }
      })
    }
  } else {
    next()
    // router.push({
    //   path: '/wb'
    // })
  }
  // debugger
  // const { urlInfo } = JSON.parse(localStorage.getItem('channelInitConfig'))
  // const gatewayPlayoutUrl = `${window.location.protocol}//${urlInfo.gatewayPlayoutUrl}`
  // $.ajax({
  //   url: `${gatewayPlayoutUrl}/tvu-playout/user/initLoginUser`,
  //   type: 'get',
  //   // headers: { Authorization: Tool.getSession() },
  //   xhrFields: {
  //     withCredentials: true
  //   },
  //   crossDomain: true,
  //   success (res, status, xhr) {
  //     if (res.errorCode == '0x0') {
  //       localStorage.setItem('userId', res.result.id)
  //       localStorage.setItem('roleId', res.result.role)
  //       const data = { userInfo: res.result } || {}
  //       $store.commit('common/BASE_USER_INFO', data)
  //       Bus.$emit('roleInfo', data.userInfo.role)
  //       if (to.meta.title && to.meta.title != undefined && to.meta.title != 'undefined') {
  //         document.title = 'TVU Channel'
  //       } else {
  //         document.title = 'TVU Channel'
  //       }
  //       const { role } = res.result
  //       if (role == '1' || role == '2') {
  //         if (pageMark == 'kb') {
  //           next()
  //         } else {
  //           router.push({
  //             path: '/kb'
  //           })
  //         }
  //       } else if (['pop', 'po', 'pt', 'wb', 'cm'].includes(pageMark)) {
  //         if (to.query.ProgramId || pageMark == 'wb' || pageMark == 'cm') {
  //           next()
  //           return
  //         }
  //         next({
  //           path: to.path,
  //           query: {
  //             ProgramId: ProgramRMessage ? JSON.parse(ProgramRMessage).ProgramId : ''
  //           }
  //         })
  //       } else {
  //         router.push({
  //           path: '/wb'
  //         })
  //       }
  //     } else if (res.errorCode == '103') {
  //       if (to.meta.title && to.meta.title != undefined && to.meta.title != 'undefined') {
  //         document.title = 'TVU Channel'
  //       } else {
  //         document.title = 'TVU Channel'
  //       }
  //       next()
  //     } else {
  //       const { urlInfo } = JSON.parse(localStorage.getItem('channelInitConfig'))
  //       window.location.href = `${urlInfo.newUserServiceUrl}/?url=${urlInfo.playoutUrl}&serviceName=${urlInfo.playoutServerName}`
  //       window.localStorage.setItem('channelSession', '')
  //       window.sessionStorage.setItem('userChangeInfo', '')
  //       sessionStorage.removeItem('ProgramRMessage')
  //     }
  //   },
  //   error (xhr) {
  //     if (xhr.status == 401 || xhr.status == 402) {
  //       const { urlInfo } = JSON.parse(localStorage.getItem('channelInitConfig'))
  //       window.location.href = `${urlInfo.newUserServiceUrl}/?url=${urlInfo.playoutUrl}&serviceName=${urlInfo.playoutServerName}`
  //       window.localStorage.setItem('channelSession', '')
  //       window.sessionStorage.setItem('userChangeInfo', '')
  //       sessionStorage.removeItem('ProgramRMessage')
  //     }
  //   }
  // })
})
export default router
